import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import { Header, Lists } from "../../components";
import { useAuth } from "../../context/AuthContext";
import { riwayatIzin } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { showError, showSessionExpired } from "../../helpers/Toast";

const RiwayatIzin = () => {
  const { handleSessionExpired } = useAuth();
  const navigate = useNavigate();
  const [riwayat, setriwayat] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const getRiwayat = async () => {
    try {
      const response = await fetch(riwayatIzin, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          handleSessionExpired();
          await showSessionExpired();
          navigate("/");
          return;
        }
        showError("Gagal memuat riwayat izin");
        return;
      }

      const data = await response.json();
      setriwayat(data.data || []);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRiwayat();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Riwayat Izin</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/home" title="Riwayat Izin" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        {isLoading ? (
          <div className="space-y-3 mt-2">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white rounded-2xl h-20 animate-pulse" />
            ))}
          </div>
        ) : riwayat && riwayat.length > 0 ? (
          riwayat.map((item, index) => (
            <Lists
              riwayatizin
              key={index}
              text={item.nama_jenisizin}
              text2={item.tgl_pengajuanizin}
              text3={item.ket_statuspengajuan}
            />
          ))
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-10 mt-2 text-center">
            <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-sm text-gray-400">Belum ada riwayat izin</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RiwayatIzin;
